import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {
  sidenavState = new Subject();
  onViewChange = new BehaviorSubject<boolean>(false);
}
